<template>
    <div v-show="nickname" :class="['inviter', { isH5: isH5 }]">
        <img v-if="avatar" class="avatar" :src="avatar" :style="avatarStyles" />
        <span class="name" v-html="nickname"></span>
    </div>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
import { isH5 } from './utils.js';

export default {
    props: {
        avatar: {
            type: String,
            default: ''
        },
        nickname: {
            type: String,
            default: ''
        },
        avatarSize: {
            type: Number,
            default: null
        },
        avatarMarginRight: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            isH5: isH5()
        };
    },
    computed: {
        avatarStyles() {
            const styles = {};

            // 如果有传入 avatarSize，则覆盖默认的 width 和 height
            if (this.avatarSize !== null && this.avatarSize !== undefined) {
                styles.width = `${this.avatarSize}rem`;
                styles.height = `${this.avatarSize}rem`;
            }

            // 如果有传入 avatarMarginRight，则覆盖默认的 margin-right
            if (this.avatarMarginRight !== null && this.avatarMarginRight !== undefined) {
                styles.marginRight = `${this.avatarMarginRight}rem`;
            }

            return styles;
        }
    }
};
</script>

<style lang="less" scoped>
.inviter {
    display: inline-flex;
    align-items: center;
    &.isH5 {
        .avatar {
            margin-right: 0.14rem;
            width: 0.5rem;
            height: 0.5rem;
            border-radius: 50%;
            overflow: hidden;
            flex-shrink: 0;
        }
        .name {
            font-size: 0.32rem;
            line-height: 1;
            color: #000;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    &:not(.isH5) {
        .avatar {
            margin-right: 0.1rem;
            width: 0.4rem;
            height: 0.4rem;
            border-radius: 50%;
            overflow: hidden;
            flex-shrink: 0;
        }
        .name {
            font-size: 0.26rem;
            line-height: 1;
            color: #000;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
</style>
